import { createReducer } from '@reduxjs/toolkit'
import { InternalSeoActions } from '@store/reducers/seo/actions'
import type { SeoFormValues } from '@store/reducers/seo/types'

const initialState: SeoFormValues = {
  description: '',
  h1_header: '',
  image: null,
  note: '',
  slug: '',
  title: '',
  url: '',
  keywords: '',
  pageIntent: '',
}

export const seoForm = createReducer<SeoFormValues>(initialState, (builder) => {
  builder
    .addCase(InternalSeoActions.init, (_, { payload }) => payload)
    .addCase(InternalSeoActions.change, (state, { payload }) => ({
      ...state,
      ...payload,
    }))
})
